<template>
  <div class="w-100 confirmation-page">
    <!-- START Navigation and related information -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <section-navigation :pageData="pageData"></section-navigation>
    </div>
    <div role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}">
    <!-- START Content Wrapper -->
    <div class="row no-gutters mx-0" style="margin-top: -1rem;">
      <div class="col">

        <!-- CONTENT HEADER-->
        <div class="row">
          <div class="col-12 pt-3 pb-2 mb-3 text-center text-white product-section-heading rounded-top">
            <h1 class="title-banner">{{ pageTitle }}</h1>
          </div>
        </div>
       <div class="row">
        <div class="col-3 carrier-logo-property">
        <img :src="pageData.carrier_final_rate_section.logoPathSvg" alt="NW" width="180.763px" height="auto"/>
        </div>
        <div class="col-3">
          <div class="row" v-for="(group, i) in pageData.fields" :key='i' v-if="group.section!=='Next Steps'">
            <template >
                <div  class="col-6 mb-2 font-weight-bold label-name">{{ group['label'] }}</div>
                <div  class="col-6 " >{{ group['field_value'] }}</div>
            </template>
          </div>
        </div>
        <div class="col-6 ">
         <!-- <div class="my-3" v-for="(group, i) in dataTree" :key='i' v-if="group"> -->
          <!-- <form-sections :group="groupSegmentsDefault()"  :pageData="pageData"></form-sections> -->
         <!-- </div> -->
         <div class="row">
           <div class="col-12">
           <div class="shadow-sm rounded">
            <div  class="py-2 pl-3 mb-2 text-white  product-section-heading rounded-top" role="heading" aria-level="3">
             Next step
           </div>
            <div class="row mx-0  pl-2">
             {{nextSteps}}
            </div>
            <div class="pl-2 mt-2" v-if="docLabel">
              <button type="button" tabindex="0" class="btn btn-primary select-carrier-btn mb-2" @click="continueToLink()" role="button">
                {{docLabel}}
                <i class="fa fa-open-in-new ml-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z" fill="currentColor"/>
                  </svg>
                </i>
              </button>
            </div>
            </div>
            </div>
            </div>
         </div>
      </div>
      <div class="row no-gutters" v-if="(homePropCov.length > 0 || homePropEndsmt.length > 0)">
        <div class="mt-3 col-md-6 shadow-sm rounded">
          <div class="py-2 pl-3 mb-2 text-white product-section-heading rounded-top">
            Coverage Summary
          </div>
          <!--SUB HEADER-->
          <template  v-if="homePropCov.length > 0">
            <div class="py-1 pl-3 mb-2 text-grey-dark bg-faint-gray" role="heading" aria-level="4">Property Coverages</div>
            <!--Liability-->
            <template v-for="(pData, pKey) in homePropCov">
            <div class="row mx-0 mb-2" :key="pKey+'homePropCov'" >
              <div class="col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray">{{pData.label}}</div>
              <div class="col-6 col-md-8 col-xl-6 text-dark-gray" >{{pData.text}}</div>
            </div>
            </template>
          </template>
          <!--SUB HEADER-->
          <template  v-if="homePropEndsmt.length > 0">
            <div class="py-1 pl-3 mt-3 text-grey-dark bg-faint-gray" role="heading" aria-level="4">Property Endorsement</div>
            <template v-for="(propData, propKey) in homePropEndsmt">
              <div class="row mx-0 mb-2" :key="propKey+'propKey'" >
                <div class="col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray">{{propData.label}}</div>
                <div class="col-6 col-md-8 col-xl-6 text-dark-gray" >{{propData.text}}</div>
              </div>
            </template>
          </template>
        </div>
      </div>
      </div>
    </div>
    <!-- END Content Wrapper -->

    <hr/>
    <!-- bottom Instruction SECTION -->
      <div v-if="footerNote()" class="d-flex justify-content-center mx-auto mt-3">
        <div class="alert alert-primary my-0 py-2 w-50" role="note">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content">{{ footerNote() }}</div>
          </div>
        </div>
      </div>
    <!-- bottom Instruction SECTION END -->
  </div>
  <dev-auto-fill :pageData="pageData"></dev-auto-fill>
  <!-- Bound Policy Alert -->
  <form-alerts v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'" :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
  </div>
</template>

<script>
// TODO: Remove eslint
/* eslint-disable */
import FormSections from '../../presentational/FormSections';
import FormAlerts from '../../presentational/alerts/FormAlerts';
import fetchData from '../../../services/fetchData';
import common from '../../../services/common';
import { pageMixin } from '../../../mixins/pageMixin';
import SectionNavigation from '@/components/presentational/widgets/SectionNavigation';

export default {
  mixins: [pageMixin],
  data() {
    return {
      pageData: {},
      nextSteps:'',
      pageTitle: '',
      dataTree: [],
      sections:[],
      routerInfo:{
        from:'',
        to:''
      },
      homePropCov: [],
      homePropEndsmt:[],
      docLabel:'',
      docLink:''
    };
  },
  components: {
    FormSections,
    FormAlerts,
    SectionNavigation,
   },
    watch: {
   'routerInfo.from' : function(newValue, oldValue) {
     this.getStatusForNav(this.routerInfo);
     },
    },
  
  beforeMount() {
    //Taking value from session once store(Vuex) getting reset on page refresh
   
   if(this.$store.getters.finalNavData.length === 0)
    {  
      if(sessionStorage.getItem("setfinalNavDataAction")){
      const finalNavfromSession=JSON.parse(sessionStorage.getItem("setfinalNavDataAction"));
      this.$store.dispatch('setfinalNavDataAction', finalNavfromSession);
       }
    }
   
  },
 
  created() {
    const finalNavData =this.$store.getters.finalNavData;
    const requestParam = {
     url: `/pages/HOPostBindCallDetails/${this.$store.getters.getSessionID}`,
    };
    const startTimeVal = (new Date()).getTime();
    fetchData.getPageData(requestParam).then((response) => {
      // log API response time through application into GA tool
      //common.gapRecordAnalyticsGeneric(startTimeVal, 'API', response.data.page_name);
      this.pageData = response.data;
      this.rc2Logo();
       if(response.data.quote_summary.quote_status === 'Bound' )
         {
          finalNavData.forEach( nav=>{
           if(nav.section === 'RC1' || nav.status==='Disabled'){
              nav.status='InactiveComplete'
           }
          });
          Object.assign(this.pageData.tab_buttons,finalNavData);
         }
       else
       {
      Object.assign(this.pageData.tab_buttons,finalNavData);
       }
      //this.pageData.tab_buttons={},
      this.pageTitle = this.pageData.carrier_final_rate_section.section;
      this.homePropCov = this.pageData.coverage_summary && this.pageData.coverage_summary.propertyCoverages ? this.pageData.coverage_summary.propertyCoverages : []; 
      this.homePropEndsmt = this.pageData.coverage_summary && this.pageData.coverage_summary.propertyEndorsements ? this.pageData.coverage_summary.propertyEndorsements : [];
      const continueButtons = this.pageData.continue_buttons || [];
      const submitLabels = continueButtons.filter(button => (button.name === 'PolicyDocumentButton')); // TODO: Use config value
      if(submitLabels.length>0){
        this.docLabel=submitLabels[0].label;
        this.docLink=submitLabels[0].on_click;
      }
      this.createTree();
      this.getNextStep();
      this.$store.dispatch('setPageName', this.pageData.page_name);
      //common.gapRecordAnalytics(response.data.page_name);
    });
     
    
    // TODO: Remove after development is complete. Only used for mock data
    // this.pageData = this.fallbackData();
    // this.pageTitle = this.pageData.carrier_final_rate_section.section;
    // this.createTree();
  },
  mounted() {
  this.routerInfo.from = sessionStorage.getItem("currentRc2FromNav");
  this.routerInfo.to = sessionStorage.getItem("currentRc2ToNav");
  },
   methods: {
    continueToLink() {
      if (this.docLink) {
        window.open(this.docLink,'_blank');
      }
    },
       
     groupSegmentsDefault(){
    const groupSegmentsDefault = [];
    groupSegmentsDefault['Next Steps']=this.dataTree[0]['Next Steps'];
    return groupSegmentsDefault;
    },
     getNextStep(){
       for (let cnt = 0; cnt < this.pageData.fields.length; cnt++) {       
        if (this.pageData.fields[cnt].section==='Next Steps') {
          this.nextSteps=this.pageData.fields[cnt].field_value;
         // this.nextSteps.push(this.pageData.fields[cnt]);

        }
       }
       console.log('this.nextSteps',this.nextSteps);
       return this.nextSteps;
      },
      getStatusForNav(inRouterInfo){
      let fromNav = inRouterInfo.from;
      let navStatusObj= {
        page_name:'',
        status:'',
      };
      let toNavStatusObj ={
        page_name:'',
        status:'',
      };
      let navStatuses=[];
      toNavStatusObj.page_name = inRouterInfo.to;
      toNavStatusObj.status='InactiveComplete';
      navStatusObj.page_name=fromNav;
      navStatusObj.status='InactiveComplete';
      navStatuses[0] = navStatusObj;
      navStatuses[1] = toNavStatusObj;
      this.$store.dispatch('setNavStatusAction', navStatuses);
      console.log('nav status calling from rule hocheckout');
    },
    footerNote() {
      let footerNote = null;

      if (this.pageData.blurbs) {
        this.pageData.blurbs.forEach((blurb) => {
          if (blurb.visible && blurb.location === 'formbottom' && blurb.content) { // TODO: Use config value
            footerNote = blurb.content;
          }
        });
      }

      return footerNote;
    },
    /**
     * Creates a tree from the data. The tree has "groups" as its nodes, and "fields" as the
     * leaves of those nodes.
     *
     * @param {Object} field_name Unique name of field
     * @param {Array} fields List of fields
     * @param {Object} field.field_name Unique name of field
     * @param {Object} field.field_type `FormBlock.vue` currently expecting value of `display`
     * @param {Object} field.group_id Int of the group the field belongs
     * @param {Object} field.group_parent Currently not in use, but will attach nodes to other nodes
     * @param {Object} field.section Name of group, which will be displayed above the 1st child of the group
     */
    createTree() {
      const dataFields = this.pageData.fields;

        for (let j = 0; j < dataFields.length; j += 1) { // Iterator over all the fields
          if (typeof this.dataTree[0] === 'undefined') {
            this.dataTree[0] = []; // Create node if it does not exist
          }

          if (! this.dataTree[0]) {
            this.dataTree[0] = [];
          }

          let section = (dataFields[j].section ? dataFields[j].section : 'untitled');
          let sub_section = (dataFields[j].sub_section ? dataFields[j].sub_section : 'untitled');
          let sub_sub_section = (dataFields[j].sub_index_section ? dataFields[j].sub_index_section : 'untitled');

          if (! this.dataTree[0][section]) {
            this.dataTree[0][section] = [];
          }

          if (! this.dataTree[0][section][sub_section]) {
            this.dataTree[0][section][sub_section] = [];
          }

          if (! this.dataTree[0][section][sub_section][sub_sub_section]) {
            this.dataTree[0][section][sub_section][sub_sub_section] = [];
          }

          this.dataTree[0][section][sub_section][sub_sub_section].push(dataFields[j]);
        }

    },
  },

};
</script>

<style scoped lang="scss">

.bg-success-blue {
  background-color: $var-qs-dark-blue;
}
.text-gray{
  color: #666666 !important;
}

.bg-gray {
  background-color: #666666 !important;
}
.carrier-logo-property
{
display: flex;
padding: 8px;
justify-content: center;
align-items: flex-start;
flex: 1 0 0;
align-self: stretch;
}
h1.title-banner::before {
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  font-weight: 600;
  content: "\f058";
  margin-right: 0.25rem;
}

/**BREAKDOWN SECTION**/
.breakdown-item{
  border-bottom: 1px solid #DEE2E6;
}

.text-grey-dark{
    color: #1A1A1A;
}
.bg-faint-gray{
    background-color: #E5EAEF;
}
.btn-primary.select-carrier-btn {
  .fa-open-in-new {
    font-size: 12px;
  }

  background-color: #FFFFFF;
  border-color: $var-color-home-icon;
  color: $var-color-home-icon;

  &:hover {
    background-color: $var-color-home-icon;
    border-color: #FFFFFF;
    color: #FFFFFF;
  }
}

/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/interview/propertyInsurance/propConfirmation.vue?7513fa5a